export default __webpack_public_path__ + "static/media/element-bg-left.0972e402.png";